import React, { useState, useEffect, useRef } from "react";
import SliderArticle from "../components/About/SliderArticle";
import Data from "../Data";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import SingleContact from "../components/About/SingleContact";
import "../components/About/About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Typed from "typed.js";

const About = () => {
  const [peoples] = useState(Data);
  const [index, setIndex] = useState(0);
  const typeContainer = useRef(null);
  const HoldType = useRef(null);
  useEffect(() => {
    const options = {
      strings: ["Linkedin", "Github", "Facebook", "Instagram"],
      typeSpeed: 200,
      backSpeed: 200,
      loop: true,
    };
    HoldType.current = new Typed(typeContainer.current, options);
    return () => HoldType.current.destroy();
  }, []);
  useEffect(() => {
    const lastIndex = Data.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index]);

  useEffect(() => {
    const Auto = setInterval(() => {
      setIndex(index + 1);
    }, 4000);
    return () => {
      clearInterval(Auto);
    };
  }, [index]);

  // this useEffect for "AOS"
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div className="contact-page">
      <section data-aos="fade-up" className="slider-section">
        {peoples.map((person, personIndex) => {
          return (
            <SliderArticle
              key={person.id}
              {...person}
              personIndex={personIndex}
              Data={Data}
              index={index}
            />
          );
        })}
        <button
          onClick={() => setIndex(index - 1)}
          className="btn-left btn-slide"
        >
          <AiFillCaretLeft />
        </button>
        <button
          onClick={() => setIndex(index + 1)}
          className="btn-right btn-slide"
        >
          <AiFillCaretRight />
        </button>
        {/* This button for slide indicator */}
        <section className="btn-slide-indicator-container">
          {peoples.map((people, peopleIndex) => {
            return (
              <button
                onClick={() => {
                  setIndex(peopleIndex);
                }}
                key={people.id}
                className={
                  peopleIndex === index ? "circle-btn active" : "circle-btn"
                }
              ></button>
            );
          })}
        </section>
      </section>
      <div data-aos="zoom-in-right" className="h1-flw-us">
        <h1 className="h1">
          Follow us via:
          <span className="auto-type-span" ref={typeContainer}></span>
        </h1>
        <div className="underlines"></div>
      </div>
      <div className="section-contact">
        {peoples.map((person) => (
          <SingleContact key={person.id} {...person} />
        ))}
      </div>
    </div>
  );
};

export default About;
